import * as AppConstants from 'app/AppConstants';
import {ROOT_PAGE_IDS} from 'constants/ObjectsConstants';
import {difference} from 'utilities/Set';

const initialState = () => ({
  entities: {},
  byStackId: {},
  byCollectionId: {},
  statisticsByCardId: {},
  withoutAccess: new Set(),
  chartTables: {},
  notebooks: {},
});

export default (state = initialState(), action) => {
  switch (action.type) {
    case AppConstants.CARD__SAVE_FINISHED: {
      return {
        ...state,
        entities: {
          ...state.entities,
          [action.payload.card.urn]: action.payload.card,
        },
        byStackId: {
          ...state.byStackId,
          [action.payload.pageId]: new Set(
            state.byStackId[action.payload.pageId]
          ).add(action.payload.card.urn),
        },
      };
    }
    case AppConstants.CARD__LOAD_FINISHED: {
      const withoutAccess = new Set(state.withoutAccess);
      withoutAccess.delete(action.payload.id);

      return {
        ...state,
        withoutAccess,
        entities: {
          ...state.entities,
          [action.payload.card.urn]: action.payload.card,
        },
      };
    }

    case AppConstants.CARD__ACCESS_DENIED:
      return {
        ...state,
        withoutAccess: new Set(state.withoutAccess).add(action.payload.id),
      };

    case AppConstants.STACK__LOAD_BY_ID_FINISHED: {
      const stack = action.payload.stack;
      const stackCardUrns = stack.cards.map(card => card.urn);
      const entities = stack.cards.reduce(
        (memo, card) => {
          memo[card.urn] = {...memo[card.urn], ...card};
          return memo;
        },
        {...state.entities}
      );
      const indexToCardUrn = index => stack.cards[index].urn.toString();
      const byCollectionId = stack.collections.reduce(
        (memo, collection) => {
          const collectionCardUrns = collection.cardIndices.map(indexToCardUrn);
          memo[collection.id] = new Set(collectionCardUrns);
          return memo;
        },
        {...state.byCollectionId}
      );

      return {
        ...state,
        entities,
        byCollectionId,
        byStackId: {
          ...state.byStackId,
          [stack.id]: new Set(stackCardUrns),
        },
      };
    }

    case AppConstants.CARD__STATISTICS_LOADED: {
      return {
        ...state,
        statisticsByCardId: {
          ...state.statisticsByCardId,
          ...action.payload.statistics,
        },
      };
    }

    case AppConstants.FAVORITE__FAVORITED_CARD:
      return {
        ...state,
        byStackId: {
          ...state.byStackId,
          [ROOT_PAGE_IDS.FAVORITES]: new Set(
            state.byStackId[ROOT_PAGE_IDS.FAVORITES]
          ).add(action.payload.id.toString()),
        },
      };

    case AppConstants.FAVORITE__UNFAVORITED_CARD:
      return {
        ...state,
        byStackId: {
          ...state.byStackId,
          [ROOT_PAGE_IDS.FAVORITES]: difference(
            state.byStackId[ROOT_PAGE_IDS.FAVORITES],
            [action.payload.id.toString()]
          ),
        },
      };

    case AppConstants.CARD__NOTEBOOK_LOADED: {
      const {id, notebook} = action.payload;
      return {
        ...state,
        notebooks: {
          ...state.notebooks,
          [id]: notebook,
        },
      };
    }

    default:
      return state;
  }
};
